<style scoped>
::v-deep .modal-window {
    padding: 0.5rem;
}
</style>

<template>
    <modal
        class="modal-3xl"
        type="custom"
        @backdrop="$emit('hide')"
        :showDismiss="true"
    >
        <div class="flex flex-col items-center">
            <div class="w-full">
                <imageLoader
                    :src="imgBanner"
                    :srcError="tinyBlankGifImg"
                    :ratio="1200 / 200"
                />
            </div>
            <bubble class="mt-4">
                <template #image>
                    <img :src="bubbleImg" class="w-16 sm:w-20" />
                </template>
                <div class="text-lg text-3xl">
                    {{ `您得到了 ${tokenNum} 次抽獎機會!` }}
                </div>
            </bubble>
            <div class="mt-8 flex flex-col">
                <router-link
                    tag="button"
                    class="btn btn-primary text-3xl px-16 py-6 mx-auto"
                    :to="{
                        name: 'promotionEvent',
                        params: { eventId: eventId }
                    }"
                >
                    {{ '前往抽獎' }}
                </router-link>
                <router-link
                    tag="button"
                    class="text-secondary underline mt-2"
                    :to="{
                        name: 'promotionEvent',
                        params: { eventId: eventId }
                    }"
                >
                    {{ '幸運輪大抽獎活動詳情' }}
                </router-link>
            </div>
        </div>
    </modal>
</template>

<script>
import modal from './modal.vue';
import bubble from './bubble.vue';
import img2s112 from '../assets/img/2-112.png';
import ctx from '../utils/ctx';
import imageLoader from '../components/imageLoader.vue';

export default {
    components: {
        modal,
        bubble,
        imageLoader
    },
    props: {
        eventId: { type: String, required: true },
        tokenNum: { type: Number, required: true }
    },
    data() {
        return {
            bubbleImg: img2s112,
            tinyBlankGifImg:
                'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
        };
    },
    computed: {
        imgBanner() {
            return ctx(`/eventImage/${this.eventId}_banner.png`);
        }
    }
};
</script>
